export default [
  {
    path: '/devices',
    name: 'homepage',
    view: 'HomePage'
  },
  {
    path: '/scenarios',
    name: 'scenariospage',
    view: 'ScenariosPage'
  },
  {
    path: '/scenarios/add',
    name: 'addscenariopage',
    view: 'AddScenarioPage'
  },
  {
    path: '/controllers',
    name: 'controllerspage',
    view: 'ControllersPage'
  },
  {
    path: '/motions/:id',
    name: 'motionhistory',
    view: 'MotionHistory'
  },
  {
    path: '/heating/:id',
    name: 'heatinghistory',
    view: 'HeatingHistory'
  },
  {
    path: '/lighting/:id',
    name: 'lightinghistory',
    view: 'LightingHistory'
  },
  {
    path: '/devices/chart',
    name: 'chartPage',
    view: 'ChartPage'
  },
  {
    path: '/devices/lighting',
    name: 'illuminancePage',
    view: 'IlluminancePage'
  },
  {
    path: '/controller/:id',
    name: 'controllerpage',
    view: 'ControllerPage'
  },
  {
    path: '/debug_controller/:id',
    name: 'debugcontrollerpage',
    view: 'DebugControllerPage'
  },
  {
    path: '/room/:id/device',
    name: 'devicepage',
    view: 'DevicePage'
  },
];
